export default "__VITE_ASSET__ByyNUk$g__"